import { makeStyles } from '@material-ui/core/styles';

import { TOPBAR_HEIGHT } from './topbar/topbar.styles';

export const useStyles = makeStyles((theme) => ({
  background: {
    height: `calc(100vh - ${TOPBAR_HEIGHT})`,
    overflow: 'hidden',
  },
}));